import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class MastersService {

  
  constructor(
    private http: HttpClient,
    public dialog: MatDialog,
    private snackbar: MatSnackBar,
  ) { }

  openSnack(message: any, action: any) {
    this.snackbar.open(message, action, { duration: 1500 });
  }

  openServiceDialog(componentName:any, height:any, width:any, maxWidth:any, dataModel:any, position: any = {right:'0px',top:'0px'}) {
    return this.dialog.open(componentName, {
      width: width,
      height: height,
      maxWidth:maxWidth,
      data: dataModel,
      disableClose: true,
      position: position,
    });
  }

  openDeleteDialog(componentName: any, height: any, width: any, dataModel: any, maxwidth: any) {
    return this.dialog.open(componentName, {
      width: width,
      height: height,
      data: dataModel,
      disableClose: true,
      maxWidth: maxwidth,
    });
  }

  openDialog(componentName: any, height: any, width: any, dataModel: any) {
    return this.dialog.open(componentName, {
      width: width,
      height: height,
      data: dataModel,
      disableClose: true,
      position: { right: '0px', top: '0px' },
    });
  }

       //Department Module Taken From Boards
     getDepartmentList(data:any){
      return this.http.put(
        environment.baseUrl+`crm/role/department/list`,data
      )
    }
    changeDepartmentStatus(status: any , id: any  ){
      return this.http.put(
        environment.baseUrl + `crm/role/department/status?status=${status}&id=${id}`,{}
      )
    }
    deleteDepartment(id: any  ){
      return this.http.delete(
        environment.baseUrl + `crm/role/depearment/delete?id=${id}`,{}
      )
    }
 
     // for add department
     addDepartment(data:any){
      return this.http.post(
        environment.baseUrl+`crm/role/department/create`,data
      )
    }
    // for upadate department
    updateDepartment(data:any){
      return this.http.put(
        environment.baseUrl+`crm/role/department`,data
      )
    }
 

    //Boards Module
    getBoardsList(data:any){
      return this.http.put(
        environment.baseUrl+`crm/master/board/filter`,data
      )
    }
    changeBoardStatus(status: any , boardId: any  ){
      return this.http.put(
        environment.baseUrl + `crm/master/board/status?status=${status}&id=${boardId}`,{}
      )
    }
    deleteBoard(boardId: any  ){
      return this.http.delete(
        environment.baseUrl + `crm/master/board?id=${boardId}`,{}
      )
    }
    // for add board
    addBoard(data:any){
      return this.http.post(
        environment.baseUrl+`crm/master/board`,data
      )
    }
    // for upadate board
    updateBoard(data:any){
      return this.http.put(
        environment.baseUrl+`crm/master/board`,data
      )
    }

    //GRADES Module

    getGradeList(data:any){
      return this.http.put(
        environment.baseUrl+`crm/master/grade/filter`,data
      )
    }
    changeGradeStatus(status: any , gradeId: any  ){
      return this.http.put(
        environment.baseUrl + `crm/master/grade/status?status=${status}&id=${gradeId}`,{}
      )
    }
    deleteGrade(gradeId: any  ){
      return this.http.delete(
        environment.baseUrl + `crm/master/deleteGradeMaster?gradeId=${gradeId}`,{}
      )
    }
    // for add board
    addGrade(data:any){
      return this.http.post(
        environment.baseUrl+`crm/master/saveOrUpdateGradeMaster`,data
      )
    }
    // for upadate board
    updateGrade(data:any){
      return this.http.put(
        environment.baseUrl+`crm/master/program`,data
      )
    }

    //Programs Module
    getProgramsList(data:any){
      return this.http.put(
        environment.baseUrl+`crm/master/program/filter`,data
      )
    }
    changeProgramStatus(status: any , id: any  ){
      return this.http.put(
        environment.baseUrl + `crm/master/program/status?status=${status}&id=${id}`,{}
      )
    }
    deleteProgram(id: any  ){
      return this.http.delete(
        environment.baseUrl + `crm/master/program?id=${id}`,{}
      )
    }
    // for add program
    addProgram(data:any){
      return this.http.post(
        environment.baseUrl+`crm/master/program`,data
      )
    }
    // for upadate campus
    updateProgram(data:any){
      return this.http.put(
        environment.baseUrl+`crm/master/program`,data
      )
    }

    //Campus Module
    getCampusList(data:any){
      return this.http.put(
        environment.baseUrl+`crm/campus/filter`,data
      )
    }
    changeCampusStatus(status: any , id: any  ){
      return this.http.put(
        environment.baseUrl + `crm/campus/status?status=${status}&id=${id}`,{}
      )
    }
    deleteCampus(id: any  ){
      return this.http.delete(
        environment.baseUrl + `crm/campus/delete?campusId=${id}`,{}
      )
    }
    // for add campus
    addCampus(data:any){
      return this.http.post(
        environment.baseUrl+`crm/campus/saveOrUpdateCampus`,data
      )
    }

    getAdmissionProcessList(){
      return this.http.get(
        environment.baseUrl+`crm/master/admissionProcessTypes`,{}
      )
    }
  
    //Sections Module
    getSectionsList(data:any){
      return this.http.put(
        environment.baseUrl+`crm/master/section/filter`,data
      )
    }
    changeSectionStatus(status: any , id: any  ){
      return this.http.put(
        environment.baseUrl + `crm/master/section/status?status=${status}&id=${id}`,{}
      )
    }
    deleteSection(id: any  ){
      return this.http.delete(
        environment.baseUrl + `crm/master/section?id=${id}`,{}
      )
    }
    // for add program
    addSection(data:any){
      return this.http.post(
        environment.baseUrl+`crm/master/section`,data
      )
    }
    // for upadate campus
    updateSection(data:any){
      return this.http.put(
        environment.baseUrl+`crm/master/section`,data
      )
    }


    // for listing in location country 
    getActiveInActiveCountryCount(){
      return this.http.get(
        environment.baseUrl+`admin/master/location/country/active/inactive`
      )
    }
  
    // for search country in template 
    getSearchCountry(page:number,size:number,searchText:any){
      return this.http.get(
        environment.baseUrl+`admin/master/location/country/search?pageNo=${page}&size=${size}&text=${searchText}`
      )
    }
    
  
    // for add country in template 
    addCountry(data:any){
      return this.http.post(
        environment.baseUrl+`admin/master/location/country`,data
      )
    }
    // for add country in template 
    updateCountry(data:any){
      return this.http.put(
        environment.baseUrl+`admin/master/location/country`,data
      )
    }
    deleteCountry(countryId:any){
      return this.http.delete(
        environment.baseUrl+`admin/master/location/country?id=${countryId}`
      )
    }

    changeToggleCountry(status: any , countryId: any  ){
      return this.http.put(
        environment.baseUrl + `admin/master/location/country/status?active=${status}&id=${countryId}`,{}
      )
    }

    countryFilter(status:any , pageNo:any ,size:any ){
      return this.http.put(
        environment.baseUrl + `admin/master/location/country/filter?active=${status}&pageNo=${pageNo}&size=${size}`,{}
      )
    }
    
    
   
     // for listing in location state 
     getStateList(page:number,size:number){
      return this.http.get(
        environment.baseUrl+`admin/master/location/state?pageNo=${page}&size=${size}`
      )
    }
  
    // for search country in template 
    getSearchState(page:number,size:number,searchText:any){
      return this.http.get(
        environment.baseUrl+`admin/master/location/state/search?pageNo=${page}&size=${size}&text=${searchText}`
      )
    }
    getActiveInActiveStateCount(){
      return this.http.get(
        environment.baseUrl+`admin/master/location/state/active/inactive`
      )
    }
  
    // for add country in template 
    addState(data:any){
      return this.http.post(
        environment.baseUrl+`admin/master/location/state`,data
      )
    }
     // for add country in template 
     updateState(data:any){
      return this.http.put(
        environment.baseUrl+`admin/master/location/state`,data
      )
    }
    deleteState(stateId:any){
      return this.http.delete(
        environment.baseUrl+`admin/master/location/state?id=${stateId}`
      )
    }
    changeToggleState(status: any , countryId: any  ){
      return this.http.put(
        environment.baseUrl + `admin/master/location/state/status?active=${status}&id=${countryId}`,{}
      )
    }

    stateFilter(data:any){
      return this.http.put(
        environment.baseUrl +`admin/master/location/state/filter`,data
      )
    }

    // for listing in location city 
    getCityList(page:number,size:number){
      return this.http.get(
        environment.baseUrl+`admin/master/location/city?pageNo=${page}&size=${size}`
      )
    }
    getActiveInActiveCityCount(){
      return this.http.get(
        environment.baseUrl+`admin/master/location/city/active/inactive`
      )
    }
    // for search country in template 
    getSearchCity(page:number,size:number,searchText:any){
      return this.http.get(
        environment.baseUrl+`admin/master/location/city/search?pageNo=${page}&size=${size}&text=${searchText}`
      )
    }
  
    // for add country in template 
    addCity(data:any){
      return this.http.post(
        environment.baseUrl+`admin/master/location/city`,data
      )
    }
    updateCity(data:any){
      return this.http.put(
        environment.baseUrl+`admin/master/location/city`,data
      )
    }
    deleteCity(cityId:any){
      return this.http.delete(
        environment.baseUrl+`admin/master/location/city?id=${cityId}`
      )
    }
    changeToggleCity(status: any , countryId: any  ){
      return this.http.put(
        environment.baseUrl + `admin/master/location/city/status?active=${status}&id=${countryId}`,{}
      )
    }
    cityFilter(data:any){
      return this.http.put(
        environment.baseUrl +`admin/master/location/city/filter`,data
      )
    }

    // for listing in location locality 
    getLocalityList(page:number, size:number){
      return this.http.get(
        environment.baseUrl+`admin/master/location/locality?pageNo=${page}&size=${size}`
      )
    }
    getActiveInActiveLocalityCount(){
      return this.http.get(
        environment.baseUrl+`admin/master/location/locality/active/inactive`
      )
    }
    // for search country in template 
    getSearchLocality(page:number,size:number,searchText:any){
      return this.http.get(
        environment.baseUrl+`admin/master/location/locality/search?pageNo=${page}&size=${size}&text=${searchText}`
      )
    }
  
    // for add country in template 
    addLocality(data:any){
      return this.http.post(
        environment.baseUrl+`admin/master/location/locality`,data
      )
    }

    updateLocality(data:any){
      return this.http.put(
        environment.baseUrl+`admin/master/location/locality`,data
      )
    }
    deleteLocality(localityId:any){
      return this.http.delete(
        environment.baseUrl+`admin/master/location/locality?id=${localityId}`
      )
    }
    changeToggleLocality(status: any , countryId: any  ){
      return this.http.put(
        environment.baseUrl + `admin/master/location/locality/status?active=${status}&id=${countryId}`,{}
      )
    }

    localityFilter(data:any){
      return this.http.put(
        environment.baseUrl +`admin/master/location/locality/filter`,data
      )
    }


    
    //AcademicYear Module
    getAcedemicYearList(data:any){
      return this.http.put(
        environment.baseUrl+`crm/master/getAcademicYearMasterByCriteria?academicYear=${data.searchText}&businessId=${data.businessId}&sortBy=${data.sortBy}&sortOrderAcademicYearMAster=${data.sortOrder}&status=${data.status}`,data
      )
    }
    // changeBoardStatus(status: any , boardId: any  ){
    //   return this.http.put(
    //     environment.baseUrl + `crm/master/board/status?status=${status}&id=${boardId}`,{}
    //   )
    // }
    deleteAcdemicYear(boardId: any  ){
      return this.http.delete(
        environment.baseUrl + `crm/master/board?id=${boardId}`,{}
      )
    }
    // for add board
    addAcdemicYear(data:any){
      return this.http.post(
        environment.baseUrl+`crm/master/board`,data
      )
    }
    // for upadate board
    updateAcdemicYear(data:any){
      return this.http.put(
        environment.baseUrl+`crm/master/board`,data
      )
    }

    getallsections(businessId: any) {
        return this.http.get(
          environment.baseUrl+`crm/master/section/grade?businessId=${businessId}`
        )
    }

    Createallocation( registrationId: any , sectionId: any ) {
      return this.http.get(
        environment.baseUrl+`crm/registration/student/convert?admissionId=${registrationId}&sectionId=${sectionId}`
      )
    }



    //ENQUIRY STATUS MODULE
    getEnquiryStatusList(data:any){
      return this.http.put(
        environment.baseUrl+`crm/master/lead-status/filter`,data
      )
    }
    changeEnquiryStatus(status: any , statusId: any  ){
      return this.http.put(
        environment.baseUrl + `crm/master/lead-status/status?status=${status}&id=${statusId}`,{}
      )
    }
    deleteEnquiryStatus(statusId: any  ){
      return this.http.delete(
        environment.baseUrl + `crm/master/lead-status?id=${statusId}`,{}
      )
    }
    // for add enquiry status
    addEnquiryStatus(data:any){
      return this.http.post(
        environment.baseUrl+`crm/master/lead-status`,data
      )
    }
    // for upadate enquiry status
    updateEnquiryStatus(data:any){
      return this.http.put(
        environment.baseUrl+`crm/master/lead-status`,data
      )
    }

      //LeadSource MODULE
    getLeadSourceList(data:any){
      return this.http.put(
        environment.baseUrl+`crm/master/lead-source/filter`,data
      )
    }
    toggleLeadSource(status: any , statusId: any  ){
      return this.http.put(
        environment.baseUrl + `crm/master/lead-source/status?status=${status}&id=${statusId}`,{}
      )
    }
    deleteLeadSource(statusId: any  ){
      return this.http.delete(
        environment.baseUrl + `crm/master/lead-source?id=${statusId}`,{}
      )
    }
    addLeadSource(data:any){
      return this.http.post(
        environment.baseUrl+`crm/master/lead-source`,data
      )
    }
    updateSource(data:any){
      return this.http.put(
        environment.baseUrl+`crm/master/lead-source`,data
      )
    }

    updateFeature(feature: any) {
  return this.http.put(
    environment.baseUrl + `crm/config/features`,
    feature
  );
}

// getAllFeatures() {
//   return this.http.get(
//     environment.baseUrl + `config/features`
//   );
// }

getFeaturesForBusiness(businessId: string) {
  return this.http.get(
    environment.baseUrl + `crm/config/features/${businessId}`
  );
}

toggleBusinessFeature(businessId: string, key: string, enabled: boolean) {
  return this.http.patch(
    environment.baseUrl + `crm/config/features/${businessId}/${key}?enabled=${enabled}`,
    {}
  );
}

addGlobalFeature(feature: any) {
  return this.http.post(
    environment.baseUrl + `crm/config/features`,
    feature
  );
}


}
